import {API_AMOCRM} from './api';

export const addTextNote = (id, text, type) => {
    return API_AMOCRM.post(`amo/notes/${type}/${id}/common`, [{text}]);
}